/**
 * I18n
 */
export const defaultNs = ["translation"]
export const defaultFormNs = ["baseCustomedForm"]
